/** @format */
import Master from '../../Layouts/Master';
import ErrorMessage from '../../../Shared/Components/ErrorMessage';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import useApi from '../../../Shared/hooks/api/Index';
import { error, success } from '../../../Shared/Components/Toast';
import Datepicker from '../../../Shared/Components/Datepicker';
import { useContext } from 'react';
import { EventContext } from '../../../Contexts/EventContext';
import { useEffect } from 'react';
import Loading from '../../../Shared/Components/Loading';
import { useParams } from 'react-router';
import moment from 'jalali-moment';

const validationSchema = Yup.object().shape({
	title: Yup.string()
		.required('عنوان الزامی است')
		.max(190, 'عنوان نمیتواند بیشتر از 190 کاراکتر باشد'),
	start_age: Yup.string().required('شروع رده سنی الزامی است'),
	end_age: Yup.string().required('پایان رده سنی الزامی است'),
	sport_id: Yup.number()
		.typeError('رشته سنی الزامی است')
		.required('رشته سنی الزامی است'),
	status: Yup.number()
		.typeError('وضعیت الزامی است')
		.required('وضعیت الزامی است')
		.min(0, 'وضعیت باید 0 و یا 1 باشد')
		.max(1, 'وضعیت باید 0 و یا 1 باشد'),
});

const EditAge = () => {
	const navigate = useNavigate();
	const { id } = useParams();
	const eventContext = useContext(EventContext);
	const [submitFormLoading, setSubmitFormLoading] = useState(false);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		getInfo();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getInfo = async () => {
		setLoading(true);
		await useApi.get(
			`/panel/base/age/${id}`,
			{},
			(res) => {
				eventContext.age = res.data.data;
			},
			(err) => {
				console.log(err);
				error('هنگام دریافت اطلاعات خطایی رخ داده است.');
				setLoading(false);
			},
		);
		await useApi.get(
			'/panel/base/sport',
			{},
			(res) => {
				eventContext.sports = res.data.data;
				setLoading(false);
			},
			(err) => {
				console.log(err);
				error('هنگام دریافت اطلاعات خطایی رخ داده است.');
				setLoading(false);
			},
		);
	};

	const onSubmitForm = async (values, setSubmitting) => {
		setSubmitFormLoading(true);

		await useApi.put(
			`/panel/base/age/${id}`,
			values,
			(res) => {
				success('رده سنی با موفقیت ویرایش شد');
				navigate('/panel/base-define/age', { replace: true });
			},
			(err) => {
				setSubmitFormLoading(false);
				error('خطایی در ثبت اطلاعات پیش آمده است.');
			},
		);
	};

	return loading ? (
		<Loading />
	) : (
		<Master>
			<Formik
				initialValues={{
					title: eventContext.age?.title,
					start_age: moment(
						eventContext.age.start_age ?? '1950-01-01',
						'YYYY-MM-DD',
					)
						.locale('fa')
						.format('YYYY/MM/DD'),
					end_age: moment(
						eventContext.age.end_age ?? '1950-01-01',
						'YYYY-MM-DD',
					)
						.locale('fa')
						.format('YYYY/MM/DD'),
					sport_id: eventContext.age?.sport?.id,
					status: eventContext.age?.status,
				}}
				onSubmit={(values, { setSubmitting }) => {
					onSubmitForm(values, setSubmitting);
				}}
				validationSchema={validationSchema}>
				{({
					values,
					errors,
					handleChange,
					handleSubmit,
					isSubmitting,
					setFieldValue,
				}) => (
					<form onSubmit={handleSubmit}>
						<div className='row border rounded mt-3'>
							<div className='col-12'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>عنوان رده سنی</label>
										<input
											name='title'
											value={values.title}
											onChange={handleChange}
											type='text'
											className='form-control'
										/>
										<ErrorMessage error={errors.title} />
									</div>
								</div>
							</div>
							<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>شروع رده سنی</label>
										<Datepicker
											handleChange={setFieldValue}
											name='start_age'
											value={values.start_age}
										/>
										<ErrorMessage error={errors.start_age} />
									</div>
								</div>
							</div>

							<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>پایان رده سنی</label>
										<Datepicker
											handleChange={setFieldValue}
											name='end_age'
											value={values.end_age}
										/>
										<ErrorMessage error={errors.end_age} />
									</div>
								</div>
							</div>
							{eventContext?.sports?.length > 0 && (
								<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
									<div className='form-group'>
										<div className='d-flex flex-column mt-1 mx-2'>
											<label>رشته ورزشی</label>
											<select
												className='form-control'
												name='sport_id'
												onChange={handleChange}
												value={values.sport_id}>
												<option>انتخاب کنید</option>
												{eventContext.sports.map((item) => (
													<option value={item.id}>{item.name_fa}</option>
												))}
											</select>
											<ErrorMessage error={errors.sport_id} />
										</div>
									</div>
								</div>
							)}

							<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
								<div className='form-group'>
									<div className='d-flex flex-column'>
										<label className='f-14 mx-2'>وضعیت</label>
										<select
											value={values.status}
											name='status'
											onChange={handleChange}
											className='form-control'>
											<option value='1'>فعال</option>
											<option value='0'>غیرفعال</option>
										</select>
										<ErrorMessage error={errors.status} />
									</div>
								</div>
							</div>
							<div className='col-12'>
								<div className='d-flex flex-row justify-content-end'>
									<button className='btn btn-info btn-sm f-14'>
										{submitFormLoading ? (
											<div
												className='spinner-border spinner-border-sm text-white mb-1'
												role='status'></div>
										) : (
											'ثبت رده سنی'
										)}
									</button>
								</div>
							</div>
						</div>
					</form>
				)}
			</Formik>
		</Master>
	);
};

export default EditAge;
